export default __webpack_public_path__ + "static/imgSixteen-1913d1b1f288faebe64e12fadf11f541.jpg";